module.exports = __webpack_public_path__ + "media/images/carousel/banner_6-4e8ac2fe24063123bb0969285eddae81.jpg";